export const configBody = [
  {
    name: 'capote',
    style: { position: 'absolute', top: '10%', left: '46%' }
  },
  { name: 'roof', style: { position: 'absolute', top: '52%', left: '46%' } },
  {
    name: 'trunk',
    style: { position: 'absolute', bottom: '10%', left: '46%' }
  },

  {
    name: 'wingFrontLeft',
    style: { position: 'absolute', top: '20%', left: '15%' }
  },
  {
    name: 'wingRearLeft',
    style: { position: 'absolute', bottom: '15%', left: '16%' }
  },
  {
    name: 'wingFrontRight',
    style: { position: 'absolute', top: '20%', right: '15%' }
  },
  {
    name: 'wingRearRight',
    style: { position: 'absolute', bottom: '15%', right: '16%' }
  },
  {
    name: 'rackFrontLeft',
    style: { position: 'absolute', top: '35%', left: '27%' }
  },
  {
    name: 'rackCentralLeft',
    style: { position: 'absolute', top: '50%', left: '25%' }
  },
  {
    name: 'rackRearLeft',
    style: { position: 'absolute', bottom: '22%', left: '26%' }
  },
  {
    name: 'rackFrontRight',
    style: { position: 'absolute', top: '35%', right: '27%' }
  },
  {
    name: 'rackCentralRight',
    style: { position: 'absolute', top: '50%', right: '25%' }
  },
  {
    name: 'rackRearRight',
    style: { position: 'absolute', bottom: '22%', right: '26%' }
  },
  {
    name: 'doorFrontRight',
    style: { position: 'absolute', top: '35%', right: '12%' }
  },
  {
    name: 'doorBackRight',
    style: { position: 'absolute', bottom: '35%', right: '12%' }
  },
  {
    name: 'doorFrontLeft',
    style: { position: 'absolute', top: '35%', left: '12%' }
  },
  {
    name: 'doorRearLeft',
    style: { position: 'absolute', bottom: '35%', left: '12%' }
  },

  {
    name: 'headlampRight',
    style: { position: 'absolute', top: '8%', right: '12%' }
  },
  {
    name: 'headlampLeft',
    style: { position: 'absolute', top: '8%', left: '12%' }
  },
  {
    name: 'bumperFront',
    style: { position: 'absolute', top: -10, left: '46%' }
  },
  {
    name: 'bumperRear',
    style: { position: 'absolute', bottom: -10, left: '46%' }
  },
  {
    name: 'lampRearLeft',
    style: { position: 'absolute', bottom: '4%', left: '18%' }
  },
  {
    name: 'lampRearRight',
    style: { position: 'absolute', bottom: '4%', right: '18%' }
  },
  {
    name: 'windshieldFront',
    style: { position: 'absolute', top: '30%', left: '46%' }
  },
  {
    name: 'windshieldRear',
    style: { position: 'absolute', bottom: '22%', left: '46%' }
  },
  {
    name: 'doorstepLeft',
    style: { position: 'absolute', top: '45%', left: '4%' }
  },
  {
    name: 'doorstepRight',
    style: { position: 'absolute', top: '45%', right: '4%' }
  }
]
export const configSalon = [
  {
    name: 'panel',
    style: { position: 'absolute', top: '26%', left: '50%' }
  },
  {
    name: 'selectorTransmissionAndHolder',
    style: { position: 'absolute', top: '40%', left: '46%' }
  },
  {
    name: 'wheel',
    style: { position: 'absolute', top: '35%', left: '35%' }
  },

  {
    name: 'seatDriver',
    style: { position: 'absolute', top: '45%', left: '35%' }
  },
  {
    name: 'seatPassangerState',
    style: { position: 'absolute', top: '45%', right: '35%' }
  },
  {
    name: 'rearSeats',
    style: { position: 'absolute', bottom: '30%', right: '45%' }
  },
  {
    name: 'luggageSpace',
    style: { position: 'absolute', bottom: '10%', right: '45%' }
  },
  {
    name: 'doorCardFrontLeft',
    style: { position: 'absolute', top: '40%', left: '13%' }
  },
  {
    name: 'doorCardFrontRight',
    style: { position: 'absolute', top: '40%', right: '13%' }
  },
  {
    name: 'doorCardRearRight',
    style: { position: 'absolute', bottom: '35%', right: '13%' }
  },
  {
    name: 'doorCardRearLeft',
    style: { position: 'absolute', bottom: '35%', left: '13%' }
  }
]
